import { t } from 'i18next';

import { Image } from '~/components/Image';
import Text from '~/components/Text';

interface Props {
  name: string;
  logoUrl: string;
}

const PublicationHeader = ({ name, logoUrl }: Props) => {
  return (
    <div className="flex flex-col items-center space-x-8 sm:flex-row">
      <div className="h-14 w-14 overflow-hidden rounded border border-gray-300 bg-white sm:h-32 sm:w-32">
        <Image maxWidth={128} aspectRatio={'square'} src={logoUrl} alt={name} />
      </div>

      <div className="space-y-4">
        <Text as="h1" type="title" size="3xl" theme={'default'} className="w-full max-w-sm font-semibold text-black">
          {name}
        </Text>
        <Text as="p" type="body" size="md" theme={'default'} className="font-regular w-full max-w-xs text-black">
          {t('publications.description')} {name}
        </Text>
      </div>
    </div>
  );
};

export default PublicationHeader;
